/**
 * Shared BroadcastChannel name for OAuth callback communication.
 * Used by useOAuthConnection, useRepoOAuthConnection, and OAuthCallbackPage
 * to coordinate between the popup and parent window when COOP blocks window.opener.
 */
export const OAUTH_CHANNEL_NAME = 'otto-oauth-channel';
